import { useState } from "react";
import { useRouteNavigation } from "../../lib/common/routes";
import { Header } from "../common/header";
import { Footer } from "./main-page/footer";
import { LAB_PRICE, TECH_PRICE } from "../../lib/common/constants";
import { useAuthContext } from "../../contexts/auth-context";

const techBenefits = [
    "Unlimited job opportunities",
    "Access to all dental employer postings",
    "Direct applications to top dental employers",
    "AI-powered job suggestions based on hobbies, interests, and skills",
];

const labBenefits = [
    {
        title: "Easy to Use Dashboard",
        description:
            "Manage your job postings, applications, and communications all in one intuitive platform.",
    },
    {
        title: "Direct Communication with Dental Candidates",
        description:
            "Message talent directly to streamline the hiring process and get the right talent faster.",
    },
    {
        title: "AI Talent/Employer Matching Feature",
        description:
            "Get AI-powered suggestions to match your open positions with the most suitable candidates.",
    },
    {
        title: "Target Dental Talent Interested in Your Area",
        description:
            "Focus on attracting talent interested in relocating or already living in your area.",
    },
    {
        title: "Dental Industry-Specific Features",
        description:
            "Our platform is built with the dental industry in mind, ensuring you find the right talent with the right skills.",
    },
];

export const Pricing = () => {
    const [isLabSelected, setIsLabSelected] = useState(true);
    const { navigateRouteClickHandler } = useRouteNavigation();
    const { isLoggedIn } = useAuthContext();

    // Toggle between Techs and Labs
    const toggleSelection = (isLab: boolean) => {
        setIsLabSelected(isLab);
    };

    return (
        <>
            <Header title="" />

            <div
                className="container-fluid bg-dark text-white pt-3"
                style={{ paddingBottom: "10rem" }}
            >
                <div className="container text-center">
                    <h1 className="display-4">Pricing</h1>
                    <h5 className="text-center mt-3 mb-4 mx-md-5 lh-base">
                        Whether you're a dental talent seeking new opportunities{" "}
                        <br />
                        or a dental employer in search of top talent,
                        <br /> choose the option that fits your goals.
                    </h5>
                    <p>
                        Click{" "}
                        <strong className="text-info">Dental Talent</strong> if
                        you're looking for job opportunities, or <br />
                        <strong className="text-info">
                            Dental Employer
                        </strong>{" "}
                        if you're ready to connect with skilled dental talent.
                    </p>
                    <div className="row">
                        <div className="col d-flex justify-content-center">
                            <div
                                className="btn-group my-5 pricing-toggle"
                                role="group"
                            >
                                <button
                                    type="button"
                                    className={`btn btn-lg rounded-start border border-2 border-light px-5 ${
                                        !isLabSelected ? "btn-info" : "btn-dark"
                                    }`}
                                    onClick={() => toggleSelection(false)}
                                >
                                    Dental Talent
                                </button>
                                <button
                                    type="button"
                                    className={`btn btn-lg rounded-end border border-2 border-light px-5 ${
                                        isLabSelected ? "btn-info" : "btn-dark"
                                    }`}
                                    onClick={() => toggleSelection(true)}
                                >
                                    Dental Employer
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="row mx-4 text-start px-2 py-4 p-md-4">
                        <div className="col-lg-10">
                            <div className="highlighted-title">
                                <h1>
                                    {" "}
                                    {isLabSelected
                                        ? "Dental Employers Get One Month Free!"
                                        : "Dental Talent Are Free!"}
                                </h1>
                            </div>
                            <div className="lh-lg">
                                {isLabSelected ? (
                                    <>
                                        For employers seeking skilled talent,
                                        our platform offers premium features to
                                        help you find the perfect fit faster.
                                        <br />
                                        Our pricing is simple and transparent.
                                        <br />
                                        <strong>
                                            👉 Just ${LAB_PRICE}/month — first
                                            month free.
                                        </strong>
                                        <p className="mt-3">
                                            Enjoy full access to:
                                        </p>
                                        <ul className="my-4">
                                            {labBenefits.map(
                                                (benefit, index) => (
                                                    <li key={index}>
                                                        <h6>{benefit.title}</h6>
                                                        <p>
                                                            {
                                                                benefit.description
                                                            }
                                                        </p>
                                                    </li>
                                                )
                                            )}
                                        </ul>
                                    </>
                                ) : (
                                    <>
                                        At WinWinGo, we believe that dental
                                        talent should have access to
                                        opportunities without paying a dime.
                                        <br />
                                        That’s why Dental Talent are always free
                                        on our platform.
                                        <br />
                                        Whether you're a seasoned expert or just
                                        starting, you can explore jobs, connect
                                        with dental employers, and apply for
                                        positions with no fees attached.
                                        <p>Enjoy full access to:</p>
                                        <ul className="list my-4">
                                            {techBenefits.map(
                                                (benefit, index) => (
                                                    <li key={index}>
                                                        {benefit}
                                                    </li>
                                                )
                                            )}
                                        </ul>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-5">
                            <div
                                className="card text-center shadow pricing-toggle position-relative bg-light pb-3"
                                style={{ top: "-40%" }}
                            >
                                <div>
                                    <h4 className="text-end mt-3">
                                        {" "}
                                        <span className="badge rounded-0 rounded-start text-wrap ms-5 lh-base text-bg-warning shadow">
                                            {isLabSelected
                                                ? "First Month Free 🎁"
                                                : ""}
                                        </span>
                                    </h4>
                                </div>
                                <div className="mx-4 mb-4">
                                    <p className="mt-3 highlighted-title fw-bold">
                                        {isLabSelected
                                            ? "Dental Employer Subscription"
                                            : "Dental Talent Subscription"}
                                    </p>
                                    <h1 className="my-2">
                                        <strong>
                                            {isLabSelected
                                                ? LAB_PRICE
                                                : TECH_PRICE}
                                        </strong>
                                        <strong style={{ fontSize: "small" }}>
                                            {" "}
                                            USD /month
                                        </strong>
                                    </h1>
                                    {isLabSelected && (
                                        <p
                                            className="my-2"
                                            style={{ fontSize: "x-small" }}
                                        >
                                            First month is free.
                                        </p>
                                        // <p>
                                        //     Cancel anytime.

                                        // </p>
                                    )}
                                    {!isLoggedIn && (
                                        <button
                                            className="btn btn-info my-3 shadow fw-bold w-75"
                                            onClick={(e) =>
                                                navigateRouteClickHandler(
                                                    isLabSelected
                                                        ? "signupLab"
                                                        : "signupTech",
                                                    e
                                                )
                                            }
                                        >
                                            {isLabSelected
                                                ? "Start Free Month"
                                                : "Get Started!"}
                                        </button>
                                    )}
                                    {/* {isLabSelected && (
                                        <p
                                            className="my-2"
                                            style={{ fontSize: "x-small" }}
                                        >
                                            Invoices and receipts available for
                                            easy company reimbursement.
                                        </p>
                                    )} */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};
